import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { MarketingService } from "src/app/Services/marketing.service";

import { LoginUsersService } from "src/app/Services/login-users.service";
import Swal from "sweetalert2";

import { EmbryoService } from "../../Services/Embryo.service";
import { StaticPagesService } from "../../Services/static-pages.service";
import { CheckoutService } from "src/app/Services/checkout.service";
import { SlugNameService } from "src/app/Services/slug-name.service";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: "embryo-HeaderCart",
    templateUrl: "./HeaderCart.component.html",
    styleUrls: ["./HeaderCart.component.scss"],
})
export class HeaderCartComponent implements OnInit {
    @Input() lang: any;
    @Input() productList: any;
    @Input() totalCount: number = 0;
    @Output() removeProductData: EventEmitter<any> = new EventEmitter();
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;

    currency = this.embryoService.currency;
    QuantatyValue = 1;
    totalCost: any;
    hiddenBadge = true;
    user: any;
    loading: boolean = false;
    enteredMenu: boolean = false;
    isMobile: any;
    disabledCheckout: boolean = false;
    disabledCheckoutBtn: boolean = false;
    userData: any;
    isGuest: boolean = false;
    environmentVariables: any;
    headerIconsColor: any;
    @Input() isCartPage: boolean = false;
    @Output() cartEmit: EventEmitter<any> = new EventEmitter();
    changeIconFill:boolean = true;
       flattenedProductList :any =[]
    productlistcopyed:any
    constructor(
        private router: Router,
        private embryoService: EmbryoService,
        private auth: LoginUsersService,
        private pagesService: StaticPagesService,
        private marketingService: MarketingService,
        public checkoutService: CheckoutService,
        private slugNameService: SlugNameService,
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {
    }

        flattenedArray:any=[]
    ngOnInit() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent
        );

        // console.log(this.productList);
        

      


        if (this.productList && this.productList.length)
            this.totalCount = this.productList.reduce(
                (a: any, b: any) => (a += b.amount),
                0
            );
        this.embryoService.productCartSub.subscribe((res) => {
            if (Array.isArray(res) || Array.isArray(res?.items)) {
                if (res?.items) {
                    if (
                        this.environmentVariables
                            ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER
                    ) {
                        this.environmentVariables.can_checkout =
                            res.can_checkout;
                    }
            
                    this.productList = res?.items;
                //  console.log(this.productList, 'res?.items');

                  
                } else {
                    this.productList = res;
                //  console.log(this.productList, 'res');

                }


         



                this.productList.forEach((product: any) => {
                    // product.slug_name = this.getProductName(product);
                });
                const itemscantbuy = this.productList.filter(
                    (item: any) =>
                        (item.can_buy != null && item.amount > item.can_buy) ||
                        item.soft_deleted
                );
                itemscantbuy.length
                    ? (this.disabledCheckout = true)
                    : (this.disabledCheckout = false);
                this.totalCount = this.productList.reduce(
                    (a: any, b: any) => (a += b.amount),
                    0
                );
            }
            this.validateCartItems(this.productList)
                //  console.log(this.productList, 'final');
            
        });
        this.getUser();
        this.isGuest = this.auth.isGuest();
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
            this.headerIconsColor = this.environmentVariables.HEADER_ICONS_FILL_COLOR;
              
            if(this.environmentVariables?.APP_SWITCH_MESSAGE_AR){
                this.iconRegistry.addSvgIconLiteral(
                    'thumbs-up', 
                    this.sanitizer.bypassSecurityTrustHtml(this.environmentVariables.APP_SWITCH_MESSAGE_AR)
                );
            }
        });
    }

//         validateCartItems(items: any) {
//         let isDisabled = false; 
//         for (let index = 0; index < items.length; index++) {
//           if(items[index].amount < items[index].min_per_order){
//             isDisabled  = true;
//           }
//         }
//   this.disabledCheckoutBtn = isDisabled; 
// }

    validateCartItems(items: any) {
   if(items.length != 0){
    if (this.environmentVariables.can_checkout) {
                 this.flattenedProductList =[]
           if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
              items.forEach((subArray: any) => {
                if (subArray && subArray.items) {
                  this.flattenedProductList.push(...subArray.items);
                }
              });
             this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
      }
      if(this.productlistcopyed){
        let isDisabled = false; 
        for (let index = 0; index < this.productlistcopyed?.length; index++) {
          if(this.productlistcopyed[index].amount < this.productlistcopyed[index].min_per_order){
            isDisabled  = true;
          }
        }
       this.disabledCheckoutBtn = isDisabled; 
      }
   }
  
      
}


    confirmationPopup(product: any, index: number) {
        this.removeProductData.emit({ product, index });
    }

    getUser() {
        if (this.auth.getUser()) {
            this.userData = this.auth.getUser();
        }
    }
    getTotalPrice() {
        this.flattenedProductList =[]
           if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
              this.productList.forEach((subArray: any) => {
                if (subArray && subArray.items) {
                  this.flattenedProductList.push(...subArray.items);
                }
              });
             this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        let total = 0;
        if (this.productlistcopyed && this.productlistcopyed?.length > 0) {
            for (const product of this.productlistcopyed) {
                product.discount_price !== null
                    ? (total += product.discount_price)
                    : (total += product.price);
            }
            return total; 
        }
        return total;
    }
    checkUserGuest() {
         if(this.environmentVariables.ENABLE_MULTI_VENDOR && this.productList.filter((x:any)=>x.items).some((a:any)=>a.has_error)){
         Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Some of your vendors have not reached the minimum purchase requirement"
                            : "لديك بعض البائعين لم تصل الي الحد الادني للشراء منهم"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });

                return
      }
        this.environmentVariables.cart_total = this.getTotalPrice();
        this.environmentVariables.can_checkout =
            this.environmentVariables?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER <
                this.environmentVariables?.cart_total ||
            this.environmentVariables
                ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER ==
                this.environmentVariables?.cart_total ||
            !this.environmentVariables?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER
                ? true
                : false;
        this.pagesService.setenvConfigOfflineApp(this.environmentVariables);
        const items = this.productList.filter(
            (item: any) =>
                item.in_stock == false ||
                item.active == false ||
                item.available_soon == true
        );
        this.user = JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
        if (this.environmentVariables.can_checkout) {
            if (items.length) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "You have items not available any more, remove them so you can proceed"
                            : "يوجد منتجات غير متاحة , احذفهم حتي يمكنك الاستمرار"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#51A351",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
                return false;
            }
            this.isGuest = this.auth.isGuest();
            if (
                this.isGuest &&
                !(
                    this.environmentVariables?.enable_affiliate ||
                    this.environmentVariables?.enable_guest_checkout
                )
            ) {
                this.router.navigate(["/" + this.lang + "/session/signin"], {
                    queryParams: { returnUrl: "/checkout" },
                });
            } else {
                this.router.navigate(["/" + this.lang + "/checkout"]);
            }
        } else {
            Swal.fire({
                html: `<p style='color:white'>${
                  this.lang === "en"
                        ? "Add " +
                          (this.environmentVariables
                              ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER - this.environmentVariables.cart_total ).toFixed(2)+ " " +this.environmentVariables.CURRENCY_CODE_EN +  " to place your order"
                        : "أضف منتجات بقيمة " +
                         (this.environmentVariables
                              ?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER - this.environmentVariables.cart_total).toFixed(2) +" "+this.environmentVariables.CURRENCY_CODE_AR + " لأستكمال طلبك" 
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#bd362f",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }
    }

    cartNavigation() {
        this.onClickCartViewCartGA4Event()
        this.marketingService.checkoutEvents(
            "checkout",
            this.productList,
            1,
            "Review Cart"
        );
        if (this.environmentVariables?.GUEST_CAN_VIEW_PRICES)
            this.router.navigate(["/" + this.lang + "/cart"]);
        else this.router.navigate(["/" + this.lang + "/session/signin"]);
    }

    calculateProductSinglePrice(product: any, value: any) {
        let price = 0;
        product.amount ? value : (value = 1);
        product.discount_price !== null
            ? (price = product.discount_price * value)
            : (price = product.price * value);

        return price;
    }

    toggleMenu(event: any, open: any) {
        if (!this.isMobile) {
            if (open) {
                event.stopPropagation();
                this.enteredMenu = false;
                this.menuTrigger.openMenu();
            } else {
                setTimeout(() => {
                    if (!this.enteredMenu) {
                        this.menuTrigger.closeMenu();
                    }
                }, 150);
            }
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
        return this.slugNameService.getProductName(product);
    }
    decrementAmountProduct(product: any) {
        if (product.amount) {
            product.amount = 0;
            this.deleteFromCart(product, "remove");
            this.removeMsg(product);
        }
    }
    public deleteFromCart(product: any, type: string | null) {
        if (!this.auth.isGuest()) {
            product.loading = true;

            if (product.in_stock) {
                const cartProduct = {
                    reset: false,
                    items: [{ id: product.id, amount: product.amount }],
                };
                this.callApiAddProductToCart(product, cartProduct, type);
            } else if (product.preorder) {
                const cartProduct = {
                    reset: false,
                    items: [{ id: product.id, amount: product.amount }],
                };
                this.callApiAddProductToCart(product, cartProduct, type);
            } else if (product.available_soon) {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is available soon"
                            : "للاسف هذا سيتوفر قريبا"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            } else {
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang === "en"
                            ? "Ops This product is out of stock"
                            : "للاسف نفد هذا المنتج من المخازن"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            }
        } else {
            this.embryoService.addToCartGuest(product, product.amount);
            // type === "add" ? this.addMsg(product) : this.removeMsg(product);
            this.isCartPage ? this.cartEmit.emit(product) : null;
        }
    }
    callApiAddProductToCart(product: any, cartProduct: any, type: any) {
        this.checkoutService.addOrUpdateToCart(cartProduct).subscribe(
            (rep: any) => {
                setTimeout(() => {
                    product.loading = false;
                }, 200);
                if (rep.code === 200) {
                    let option;
                    type === "add"
                        ? (option = "AddToCart")
                        : (option = "RemoveFromCart");
                    this.marketingService.fbTracking("track", option, {
                        content_ids: [product.sku],
                        content_type: "product",
                        content_name: product.name,
                        value: product.discount_price
                            ? product.discount_price
                            : product.price,
                        contents: [
                            { id: product.sku, quantity: product.amount },
                        ],
                        currency:  this.environmentVariables?.CURRENCY_CODE_EN,
                    });

                   this.marketingService.snapTracking("track", 'ADD_CART', {
                        item_ids: [product.sku],
                        number_items: product.amount,
                        price: product.discount_price
                            ? product.discount_price
                            : product.price,
                        currency: this.environmentVariables?.CURRENCY_CODE_EN,
                    });

           



                    // type === "add"
                    //     ? this.addMsg(product)
                    //     : this.removeMsg(product);
                    this.embryoService.productCartSub.next(
                        rep.data.items ? rep.data.items : rep.data
                    );
                }
            },
            () =>
                setTimeout(() => {
                    product.loading = false;
                }, 200)
        );
    }
    removeMsg(product: any) {
        this.marketingService.cartEvents("removeFromCart", product, "remove");
        const toastOption = {
            title: "Cart",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Cart";
            toastOption.msg = "Product removed from cart successfully";
        } else {
            toastOption.title = "العربة";
            toastOption.msg = "تم إزالة المنتج من العربة بنجاح";
        }
        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    getProductListCount(list:any){
           this.flattenedArray =[];
         if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
            list.forEach((subArray:any)=> {
            if (subArray && subArray.items !== undefined) {
              this.flattenedArray.push(...subArray.items);
           }
            }); 
            return this.flattenedArray.length ;     
              }else{
            return this.productList.length ;   
          }
        
    }

    onClickCartViewCartGA4Event(){
    
        if(this.productList.length &&this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID ){

            let data = {
                currency:this.environmentVariables.CURRENCY_CODE_EN,
                value:this.getTotalPriceProduct(),
            }
            this.marketingService.GA4ViewCartEvent(data)
        }
    }
    getTotalPriceProduct(){
        let total = 0;
        total =   this.productList.reduce((acc:any,product:any)=>{
           if(product.discount_price){
               acc += product.discount_price;
           } else {
               acc  += product.price
           }
           return acc
         },0)
         return total.toString()
    }
}
